<template>
  <image-aside-slide
    class="tagged-image-aside-slide"
    v-bind:image-src="image.image"
    v-bind:image-alt="image.alt_text"
    v-bind:image-width="image.width"
    v-bind:image-height="image.height"
    v-bind:preferred-image-position="preferredImagePosition"
  >
    <div class="text-block">
      <h2>{{ image.title }}</h2>
      <!-- eslint-disable-next-line -->
      <p v-for="paragraph in descriptionParagraphs">{{ paragraph }}</p>
    </div>
  </image-aside-slide>
</template>

<script>
import ImageAsideSlide from './ImageAsideSlide'

export default {
  name: 'TaggedImageAsideSlide',
  props: ['image', 'preferred-image-position'],
  components: {ImageAsideSlide},
  data () {
    return {}
  },
  computed: {
    descriptionParagraphs: function () {
      return (this.image) ? this.image.description.split('\n') : []
    }
  }
}
</script>

<style scoped lang="scss">
  .tagged-image-aside-slide {
    background-color: black;
    & >>> .image-aside-description.full-screen {
      @include media (">tablet") {
        padding: 2em 0;
        background-color: $inverse-background-color;
        color: $inverse-text-color;
        h2 { color: $inverse-text-color; }
      }
    }
    .text-block {
      @include text-block();
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/TaggedImageAsideSlide.vue